import { loading } from "@/core/src";
import { Controller } from "@hotwired/stimulus";
import { dispatchUnexpectedErrorOccurred } from "../../events/erroroccurred";
import { dispatchErrorsCleared } from "../../events/errorscleared";
import { parseJsonResponse } from "../../http_helpers";
export default class default_1 extends Controller {
    constructor() {
        super(...arguments);
        this.model = null;
    }
    get form() {
        if (this.hasFormTarget && this.formTarget instanceof HTMLFormElement) {
            return this.formTarget;
        }
        throw new Error("No compatible 'form' target specified.");
    }
    // meant to be overriden to further prepare the form
    setUpForm(event) {
        this.cancelButtonTarget.classList.remove(this.hiddenClass);
        this.form.reset();
        this.model = event.detail;
    }
    cancelUpdate() {
        this.clearForm();
        this.model = null;
        this.dispatch("updateCancelled");
    }
    clearForm() {
        this.cancelButtonTarget.classList.add(this.hiddenClass);
        this.form.reset();
    }
    async handleSubmit(event) {
        event.preventDefault();
        if (!this.isFormValid()) {
            return;
        }
        const request = this.getFormSubmitRequest();
        const done = this.prepareSubmit();
        let response;
        try {
            response = await parseJsonResponse(this, await window.fetch(request));
        }
        catch (error) {
            dispatchUnexpectedErrorOccurred(this, error);
        }
        finally {
            done();
        }
        if (typeof response === "undefined") {
            return;
        }
        if (this.model === null) {
            this.clearForm();
        }
        this.dispatch("dataHasChanged", {
            prefix: "",
            detail: this.model || undefined,
        });
    }
    async handleDelete(event) {
        const { data: model, initiator } = event.detail;
        initiator.disabled = true;
        if (!window.confirm(`¿Desea realmente eliminar "${model.name}"? Esta acción no se puede revertir.`)) {
            initiator.disabled = false;
            return;
        }
        const done = this.prepareDelete(initiator);
        let response;
        try {
            response = parseJsonResponse(this, await window.fetch(this.deleteUrlValue, {
                method: "POST",
                body: new URLSearchParams({ id: model.id.toString() }),
            }));
        }
        catch (error) {
            dispatchUnexpectedErrorOccurred(this, error);
        }
        finally {
            done();
        }
        if (typeof response === "undefined") {
            return;
        }
        this.dispatch("dataHasChanged", { prefix: "" });
    }
    // random utilities
    trim(event) {
        if (event.target instanceof HTMLInputElement) {
            event.target.value = event.target.value.trim();
        }
    }
    // meant to be overriden to further prepare submittal
    prepareSubmit() {
        dispatchErrorsCleared(this);
        this.submitterTarget.disabled = true;
        const loadingDone = loading(this.submitterTarget, "Enviando...");
        return () => {
            this.submitterTarget.disabled = false;
            loadingDone();
        };
    }
    // meant to be overriden to further prepare deletion
    prepareDelete(initiator) {
        dispatchErrorsCleared(this);
        const loadingDone = loading(initiator, "Eliminando...");
        return () => {
            initiator.disabled = false;
            loadingDone();
        };
    }
    getFormSubmitUrl() {
        return this.model === null ? this.createUrlValue : this.updateUrlValue;
    }
}
default_1.classes = ["hidden"];
default_1.targets = ["form", "submitter", "cancelButton"];
default_1.values = {
    createUrl: String,
    updateUrl: String,
    deleteUrl: String,
};
//# sourceMappingURL=main_controller.js.map